
import BasicNavigationControl from '../components/navigation/BasicNavigationControl.vue';
import { Options, Prop, Vue } from 'vue-property-decorator';

@Options({
  components: { BasicNavigationControl },
})
export default class NavigationFooter extends Vue {
  @Prop() readonly previousButtonText: string | undefined;
  @Prop() readonly nextButtonText: string | undefined;
  @Prop({ default: false }) readonly useSubmitIcon: boolean | undefined;

  adjustTopBorderLayout(removeTopRadius: boolean): void {
    const navigationContainer = this.$el.querySelector('#navigation-container');
    if (removeTopRadius) {
      navigationContainer.classList.remove('top-border-with-radius');
      navigationContainer.classList.add('top-border-without-radius');
    } else {
      navigationContainer.classList.add('top-border-with-radius');
      navigationContainer.classList.remove('top-border-without-radius');
    }
  }
}
